/**
 * UI strings for the self-made animation set (ast.*): loading lines, intro clip captions,
 * ask-a-grown-up purchase states, app-update announcement, testimonials, split-screen tip,
 * asset gallery. `vi` must cover every `en` key.
 */
export const en = {
  'ast.loading.1': 'Drawing is good for the brain',
  'ast.loading.2': 'Every line makes you better',
  'ast.loading.3': 'Mistakes are happy accidents',
  'ast.loading.4': 'Grab a pencil and some paper',
  'ast.intro.1': 'Meet Sketchling!',
  'ast.intro.2': 'Watch a teacher draw, step by step',
  'ast.intro.3': 'Draw along on real paper',
  'ast.intro.4': 'Snap a photo of your drawing',
  'ast.intro.5': 'Keep it in your journal and earn sparks',
  'ast.intro.6': 'Celebrate with the whole family!',
  'ast.intro.label': 'How Sketchling works',
  'ast.deferred.request': 'Ask a grown-up',
  'ast.deferred.sent': 'Request sent!',
  'ast.deferred.pending': 'Waiting for a grown-up to approve…',
  'ast.deferred.approved': 'Approved! Enjoy drawing.',
  'ast.deferred.denied': 'Not this time. You can ask again later.',
  'ast.update.title': "What's new",
  'ast.update.force': 'A new version is required to keep drawing.',
  'ast.update.optional': 'A new version with fresh drawings is ready.',
  'ast.update.item1': 'New lessons every week',
  'ast.update.item2': 'Smoother camera capture',
  'ast.update.item3': 'More stickers for your journal',
  'ast.update.cta': 'Update now',
  'ast.testimonials': 'Families love drawing together',
  'ast.testi.1': '“My daughter draws every evening now.”',
  'ast.testi.1by': 'Parent of a 7-year-old',
  'ast.testi.2': '“The step-by-step pauses are perfect for little hands.”',
  'ast.testi.2by': 'Parent of twins',
  'ast.testi.3': '“We fill a journal page together every weekend.”',
  'ast.testi.3by': 'Grandparent',
  'ast.split.title': 'Need more room?',
  'ast.split.body': 'Turn your device sideways or use the full screen to draw along.',
  'ast.gallery': 'Animation & sound gallery',
} as const;

export const vi: Record<keyof typeof en, string> = {
  'ast.loading.1': 'Vẽ tranh rất tốt cho trí não',
  'ast.loading.2': 'Mỗi nét vẽ giúp bạn giỏi hơn',
  'ast.loading.3': 'Vẽ sai cũng là một bất ngờ thú vị',
  'ast.loading.4': 'Lấy bút chì và giấy ra nào',
  'ast.intro.1': 'Chào mừng đến với Sketchling!',
  'ast.intro.2': 'Xem cô giáo vẽ từng bước',
  'ast.intro.3': 'Vẽ theo trên giấy thật',
  'ast.intro.4': 'Chụp ảnh bức vẽ của bạn',
  'ast.intro.5': 'Lưu vào nhật ký và nhận tia sáng',
  'ast.intro.6': 'Cả nhà cùng ăn mừng!',
  'ast.intro.label': 'Sketchling hoạt động thế nào',
  'ast.deferred.request': 'Hỏi người lớn',
  'ast.deferred.sent': 'Đã gửi yêu cầu!',
  'ast.deferred.pending': 'Đang chờ người lớn đồng ý…',
  'ast.deferred.approved': 'Đã được đồng ý! Vẽ vui nhé.',
  'ast.deferred.denied': 'Lần này chưa được. Bạn có thể hỏi lại sau.',
  'ast.update.title': 'Có gì mới',
  'ast.update.force': 'Cần cập nhật phiên bản mới để tiếp tục vẽ.',
  'ast.update.optional': 'Đã có phiên bản mới với nhiều bài vẽ mới.',
  'ast.update.item1': 'Bài học mới mỗi tuần',
  'ast.update.item2': 'Chụp ảnh mượt hơn',
  'ast.update.item3': 'Thêm nhãn dán cho nhật ký',
  'ast.update.cta': 'Cập nhật ngay',
  'ast.testimonials': 'Các gia đình thích cùng nhau vẽ',
  'ast.testi.1': '“Con gái tôi giờ tối nào cũng vẽ.”',
  'ast.testi.1by': 'Phụ huynh bé 7 tuổi',
  'ast.testi.2': '“Các điểm dừng từng bước rất hợp với tay bé.”',
  'ast.testi.2by': 'Phụ huynh bé sinh đôi',
  'ast.testi.3': '“Cuối tuần nào cả nhà cũng vẽ một trang nhật ký.”',
  'ast.testi.3by': 'Ông bà',
  'ast.split.title': 'Cần thêm chỗ?',
  'ast.split.body': 'Xoay ngang thiết bị hoặc dùng toàn màn hình để vẽ theo.',
  'ast.gallery': 'Thư viện hoạt ảnh & âm thanh',
};
